module.exports = "/_next/static/images/icon_45-accb7234672793986b3272572cb8c0e7.png";